import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1300GetPlanNumListModel } from '../vo/kymw1300-get-plan-num-list.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 商品企画マスタ画面　計画数一覧を取得するサービス
 *
 * @export GetPlanNumListService
 * @class GetPlanNumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanNumListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetPlanNumListService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetPlanNumListService
   */
  private vo: KYMW1300GetPlanNumListModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPlanNumListService
   */
  private successFunc: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanNumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DispMode: this.vo.dispMode,
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        SellAreaCode: this.vo.sellAreaCode,
        OrderNumQuotaCode: this.vo.orderNumQuotaCode,
        CoopCode: this.vo.coopCode,
        ClassCode: this.vo.classCode,
        MiddleClassCode: this.vo.middleClassCode,
        SmallClassCode: this.vo.smallClassCode,
        PageNo: this.vo.page,
        BuyerCode: this.vo.buyerCode,
        OrdrClientCode: this.vo.orderClientCode,
        OrdrClientKanji: this.vo.orderClientKanji,
        PayeeClientCode: this.vo.payeeClientCode,
        PayeeClientKanji: this.vo.payeeClientKanji
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPlanNumListService
   */
  execute(model: KYMW1300Model, vo: KYMW1300GetPlanNumListModel, successFunc: (model: any) => void): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPlanNumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanNumListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
